import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { arrayOf, bool, shape } from 'prop-types';
import { formatNumberWithoutDecimals } from 'utils/helpers/format';
import * as R from 'ramda';

const CustomMaxTooltip = ({ active, payload, tooltipData }) => {
  const findValue = (name, val) => {
    const toLower = `${name.charAt(0).toLowerCase()}${name.slice(1)}`;
    const combined = toLower.split(' ').join('');
    return tooltipData[combined][val];
  };

  if (active && payload.length) {
    return (
      <Box
        sx={{
          backgroundColor: 'surface.white',
          borderRadius: 0.5,
          boxShadow: 6,
          p: 2,
        }}
      >
        <Stack spacing={1}>
          <Typography sx={{ fontWeight: 700 }} variant="body1">
            {payload[0].name}
          </Typography>
          <Typography sx={{ fontWeight: 700 }} variant="body1">
            Total: {formatNumberWithoutDecimals(payload[0].value)} bbl
          </Typography>
          {R.not(
            R.or(R.equals('Max', payload[0].name), R.equals('Contract Max', payload[0].name))
          ) && (
            <Stack spacing={0.5}>
              <Typography color="text.disabled" variant="caption">
                Controlled: {formatNumberWithoutDecimals(findValue(payload[0].name, 'controlled'))}{' '}
                bbl
              </Typography>
              <Typography color="text.disabled" variant="caption">
                Uncontrolled:{' '}
                {formatNumberWithoutDecimals(findValue(payload[0].name, 'uncontrolled'))} bbl
              </Typography>
            </Stack>
          )}
        </Stack>
      </Box>
    );
  }

  return null;
};

CustomMaxTooltip.propTypes = {
  active: bool,
  payload: arrayOf(shape({})),
  tooltipData: shape({}),
};

CustomMaxTooltip.defaultProps = {
  active: null,
  payload: [],
  tooltipData: null,
};

export default CustomMaxTooltip;
